var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGodotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_62_91)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 90,
    height: 90,
    rx: 20,
    fill: "url(#paint0_linear_62_91)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_62_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.45 45.03C62.2858 45.03 62.1233 45.0624 61.9716 45.1252C61.82 45.188 61.6822 45.2801 61.5661 45.3961C61.45 45.5122 61.358 45.65 61.2951 45.8017C61.2323 45.9533 61.2 46.1159 61.2 46.28C61.2 46.4442 61.2323 46.6067 61.2951 46.7584C61.358 46.91 61.45 47.0478 61.5661 47.1639C61.6822 47.28 61.82 47.3721 61.9716 47.4349C62.1233 47.4977 62.2858 47.53 62.45 47.53C62.7815 47.53 63.0995 47.3983 63.3339 47.1639C63.5683 46.9295 63.7 46.6115 63.7 46.28C63.7 45.9485 63.5683 45.6306 63.3339 45.3961C63.0995 45.1617 62.7815 45.03 62.45 45.03Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_62_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7667 55.6233L21.75 57.7833C21.755 58.75 21.7667 59.8116 21.7667 60.0216C21.7667 69.53 33.8283 74.1 48.815 74.1533H48.8517C63.8367 74.1 75.895 69.53 75.895 60.0216C75.895 59.8066 75.89 56.5916 75.895 55.6233",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1417 26.67C72.2516 27.6235 70.4201 28.6888 68.6567 29.86C67.785 28.9933 66.8033 28.285 65.84 27.5433C64.8917 26.7833 63.8233 26.2267 62.8117 25.5767C63.1117 23.33 63.2617 21.12 63.3217 18.8133C60.71 17.4983 57.9217 16.6267 55.105 16C53.9757 17.9207 52.9574 19.9045 52.055 21.9417C50.9965 21.7739 49.9267 21.6881 48.855 21.685H48.8133C47.7417 21.6881 46.6718 21.7739 45.6133 21.9417C44.7104 19.9045 43.6915 17.9206 42.5617 16C39.745 16.6267 36.9583 17.5 34.345 18.8133C34.405 21.12 34.5533 23.33 34.8567 25.5767C33.84 26.2267 32.775 26.7833 31.8283 27.5433C30.865 28.285 29.8817 28.9933 29.01 29.86C27.2466 28.6888 25.415 27.6235 23.525 26.67C21.4783 28.8733 19.5633 31.2517 18 33.9117C19.1416 35.7734 20.3869 37.5696 21.73 39.2917H21.7683V55.625L21.8567 55.6283L31.87 56.5933C32.3933 56.6433 32.8033 57.065 32.8417 57.5917L33.15 62.0117L41.8833 62.635L42.4833 58.555C42.5223 58.2994 42.6514 58.0662 42.8474 57.8974C43.0433 57.7287 43.2931 57.6356 43.5517 57.635H54.115C54.6483 57.635 55.1033 58.0267 55.1817 58.555L55.7817 62.635L64.5167 62.0117L64.825 57.5917C64.8433 57.3373 64.9508 57.0975 65.1286 56.9146C65.3063 56.7316 65.5429 56.6173 65.7967 56.5917L75.805 55.6283L75.895 55.6233V54.32H75.8983V39.2917H75.935C77.2786 37.5696 78.5245 35.7735 79.6667 33.9117C78.1033 31.2517 76.1883 28.8733 74.1417 26.67ZM34.64 51.955C33.8477 51.955 33.0631 51.7989 32.3311 51.4957C31.5991 51.1925 30.934 50.7481 30.3738 50.1879C29.8135 49.6276 29.3691 48.9625 29.0659 48.2305C28.7627 47.4985 28.6067 46.714 28.6067 45.9217C28.6067 45.1294 28.7627 44.3448 29.0659 43.6128C29.3691 42.8808 29.8135 42.2157 30.3738 41.6555C30.934 41.0952 31.5991 40.6508 32.3311 40.3476C33.0631 40.0444 33.8477 39.8883 34.64 39.8883C36.2401 39.8883 37.7747 40.524 38.9062 41.6555C40.0377 42.7869 40.6733 44.3215 40.6733 45.9217C40.6733 47.5218 40.0377 49.0564 38.9062 50.1879C37.7747 51.3193 36.2401 51.955 34.64 51.955ZM63.0267 51.955C61.4265 51.9554 59.8917 51.3202 58.76 50.1891C57.6282 49.0579 56.9921 47.5235 56.9917 45.9233C56.9912 44.3232 57.6265 42.7884 58.7576 41.6566C59.8888 40.5249 61.4232 39.8888 63.0233 39.8883C64.6235 39.8879 66.1583 40.5231 67.29 41.6543C68.4218 42.7854 69.0579 44.3199 69.0583 45.92C69.0588 47.5201 68.4235 49.0549 67.2924 50.1867C66.1612 51.3185 64.6268 51.9546 63.0267 51.955Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_62_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2167 45.03C35.0525 45.03 34.89 45.0624 34.7383 45.1252C34.5866 45.188 34.4488 45.2801 34.3328 45.3961C34.2167 45.5122 34.1246 45.65 34.0618 45.8017C33.999 45.9533 33.9667 46.1159 33.9667 46.28C33.9667 46.4442 33.999 46.6067 34.0618 46.7584C34.1246 46.91 34.2167 47.0478 34.3328 47.1639C34.4488 47.28 34.5866 47.3721 34.7383 47.4349C34.89 47.4977 35.0525 47.53 35.2167 47.53C35.5482 47.53 35.8661 47.3983 36.1005 47.1639C36.335 46.9295 36.4667 46.6115 36.4667 46.28C36.4667 45.9485 36.335 45.6306 36.1005 45.3961C35.8661 45.1617 35.5482 45.03 35.2167 45.03Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_62_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8317 45.0867V50.8383",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_62_91",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_91",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_62_91",
    x: 57.2,
    y: 45.03,
    width: 10.5,
    height: 10.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_91",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_62_91",
    x: 12.5,
    y: 14.4999,
    width: 72.6667,
    height: 69.1534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_91",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_62_91",
    x: 29.9667,
    y: 45.03,
    width: 10.5,
    height: 10.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_91",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_62_91",
    x: 43.8942,
    y: 44.1492,
    width: 9.875,
    height: 15.6267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_62_91"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_62_91",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_91",
    x1: 49,
    y1: 0,
    x2: 49,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ADF7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodotIcon);
export default __webpack_public_path__ + "static/media/godot_icon.8d0aed12d879b904ad26d8065101e17e.svg";
export { ForwardRef as ReactComponent };